// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__FY0mv","title":"Settings_title__gfzYZ"};